
var appVersion = "26.07.01";

export const appInfo = () => {

 return {
      title: 'mobiSupport',
      version: appVersion,
      apiURL: 'https://api.fbsshop.de',
    };
}